const redirectUri = process.env.VUE_APP_AUTHREDIRECT_URI;
const clientId = process.env.VUE_APP_CLIENTID;

export default {
    clientId: clientId,
    redirectUri: redirectUri,
    authority: "https://login.microsoftonline.com/16b235d7-7e90-4ec4-b250-06a515d69e4a"
};
